import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiPlay, FiTarget, FiZap } from 'react-icons/fi';
import ScrollToTop from '../utils/ScrollToTop';

export default function Intro({ onStart }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="flex flex-col items-center justify-center min-h-[80vh] text-center px-4"
    >
      <ScrollToTop />
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/15 border border-blue-400/30 text-blue-300 text-sm mb-8">
        <SafeIcon icon={FiZap} />
        <span>Kein Standard-Mathe-Test</span>
      </div>
      <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight text-white mb-6">
        Finde deinen <br />
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-violet-400">
          Denkmodus.
        </span>
      </h1>
      <p className="text-xl text-slate-200 max-w-2xl mb-12 leading-relaxed">
        Wie gehst du eigentlich an Probleme heran? Finde heraus, ob du der Struktur-Sucher, der
        Intuitive oder der Überdenker bist. In nur 2 Minuten.
      </p>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={onStart}
        className="group relative px-8 py-4 bg-white text-slate-900 font-bold rounded-2xl text-lg flex items-center gap-3 overflow-hidden shadow-xl"
      >
        <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-blue-100 to-violet-100 opacity-0 group-hover:opacity-100 transition-opacity" />
        <span className="relative z-10">Mission starten</span>
        <SafeIcon icon={FiPlay} className="relative z-10" />
      </motion.button>
      <div className="mt-16 flex items-center gap-8 text-slate-300 text-sm font-medium">
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiTarget} className="text-blue-400" />
          <span>3 Situationen</span>
        </div>
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiZap} className="text-amber-400" />
          <span>Direktes Feedback</span>
        </div>
      </div>
    </motion.div>
  );
}